import React from 'react';
import Box from '@mui/material/Box';

type AllProps = React.AllHTMLAttributes<React.PropsWithChildren<unknown>> & {
  style?: any;
  className?: any;
};

const FirstColumnContainer: React.FC<React.PropsWithChildren<AllProps>> = ({
  children,
  style,
  className,
}: AllProps) => (
  <Box sx={{ minWidth: 400, maxWidth: 400 }} style={style} className={className}>
    { children }
  </Box>
);

export default FirstColumnContainer;
